exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-InputWithButton__input {\n  padding-top: 1.3rem !important;\n  padding-bottom: 1.3rem !important; }\n  .m-InputWithButton__input::placeholder {\n    color: #adadad !important;\n    line-height: 1.5rem; }\n  .m-InputWithButton__input::-webkit-input-placeholder {\n    color: #adadad !important;\n    line-height: 1.5rem; }\n  .m-InputWithButton__input:-moz-placeholder {\n    color: #adadad !important;\n    line-height: 1.5rem; }\n  .m-InputWithButton__input:-ms-input-placeholder {\n    color: #adadad !important;\n    line-height: 1.5rem; }\n", ""]);

// exports
